// Icons used by the Daily Dose frames (009 T031), redrawn from the reference export's SVG assets.
import { createIcon } from './createIcon';

export { createIcon } from './createIcon';
export type { Icon, IconProps } from './createIcon';

/** Back arrow (article detail). */
export const ArrowLeftIcon = /* @__PURE__ */ createIcon(
  'ArrowLeftIcon',
  '0 0 18 18',
  <path d="M9 3.75 3.75 9 9 14.25M3.75 9h10.5" />,
  {
    directional: true,
  },
);
/** Back chevron (onboarding). */
export const ChevronLeftIcon = /* @__PURE__ */ createIcon(
  'ChevronLeftIcon',
  '0 0 16 16',
  <path d="M10 4 6 8l4 4" />,
  { directional: true },
);
/** Next chevron. */
export const ChevronRightIcon = /* @__PURE__ */ createIcon(
  'ChevronRightIcon',
  '0 0 16 16',
  <path d="m6 4 4 4-4 4" />,
  { directional: true },
);
/** Open-list chevron (selects). */
export const ChevronDownIcon = /* @__PURE__ */ createIcon(
  'ChevronDownIcon',
  '0 0 16 16',
  <path d="m4 6 4 4 4-4" />,
);
/** Search (fields and the Explore tab). */
export const SearchIcon = /* @__PURE__ */ createIcon(
  'SearchIcon',
  '0 0 20 20',
  <path d="m14.17 14.17 3.33 3.33M2.5 8.75a6.25 6.25 0 1 0 12.5 0 6.25 6.25 0 0 0-12.5 0Z" />,
);
/** Home tab. */
export const HomeIcon = /* @__PURE__ */ createIcon(
  'HomeIcon',
  '0 0 20 20',
  <path d="M12.5 17.5v-6.67a.83.83 0 0 0-.83-.83H8.33a.83.83 0 0 0-.83.83v6.67M2.5 8.33a1.67 1.67 0 0 1 .59-1.27l5.83-5a1.67 1.67 0 0 1 2.16 0l5.83 5a1.67 1.67 0 0 1 .59 1.27v7.5a1.67 1.67 0 0 1-1.67 1.67H4.17A1.67 1.67 0 0 1 2.5 15.83v-7.5Z" />,
);
/** Interests tab: four squares. */
export const GridIcon = /* @__PURE__ */ createIcon(
  'GridIcon',
  '0 0 20 20',
  <>
    <rect x="0" y="0" width="8" height="8" rx="2" />
    <rect x="12" y="0" width="8" height="8" rx="2" />
    <rect x="0" y="12" width="8" height="8" rx="2" />
    <rect x="12" y="12" width="8" height="8" rx="2" />
  </>,
  { fill: true },
);
/** Profile tab. */
export const UserIcon = /* @__PURE__ */ createIcon(
  'UserIcon',
  '0 0 20 20',
  <path d="M15.83 17.5v-1.67a3.33 3.33 0 0 0-3.33-3.33h-5a3.33 3.33 0 0 0-3.33 3.33v1.67M13.33 5.83a3.33 3.33 0 1 1-6.66 0 3.33 3.33 0 0 1 6.66 0Z" />,
);
/** Notification bell. */
export const BellIcon = /* @__PURE__ */ createIcon(
  'BellIcon',
  '0 0 18 18',
  <path d="M7.7 15.75a1.5 1.5 0 0 0 2.6 0M2.45 11.49a.75.75 0 0 0 .55 1.26h12a.75.75 0 0 0 .55-1.26C14.56 10.47 13.5 9.37 13.5 6a4.5 4.5 0 0 0-9 0c0 3.37-1.06 4.47-2.05 5.49Z" />,
);
/** Like (heart). */
export const HeartIcon = /* @__PURE__ */ createIcon(
  'HeartIcon',
  '0 0 22 22',
  <path d="M11 18.5S2.75 13 2.75 7.5c0-2.75 2.3-4.58 4.58-4.58C9.17 2.92 11 4.3 11 4.3s1.83-1.38 3.67-1.38c2.29 0 4.58 1.83 4.58 4.58C19.25 13 11 18.5 11 18.5Z" />,
);
/** Save (bookmark). */
export const BookmarkIcon = /* @__PURE__ */ createIcon(
  'BookmarkIcon',
  '0 0 22 22',
  <path d="M15.58 2.75H6.42A1.83 1.83 0 0 0 4.58 4.58v13.75a.92.92 0 0 0 1.37.8l4.14-2.37a1.83 1.83 0 0 1 1.82 0l4.14 2.37a.92.92 0 0 0 1.37-.8V4.58a1.83 1.83 0 0 0-1.84-1.83Z" />,
);
/** Add (to a magazine). */
export const PlusIcon = /* @__PURE__ */ createIcon(
  'PlusIcon',
  '0 0 22 22',
  <path d="M11 4.25v13.5M4.25 11h13.5" />,
);
/** Share. */
export const ShareIcon = /* @__PURE__ */ createIcon(
  'ShareIcon',
  '0 0 22 22',
  <path d="m7.87 12.38 6.26 3.65m0-10.06L7.87 9.62M19.25 4.58a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0ZM8.25 11a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm11 6.42a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z" />,
);
/** Lock (privacy note). */
export const LockIcon = /* @__PURE__ */ createIcon(
  'LockIcon',
  '0 0 14 14',
  <path d="M4.08 5.83V4.08a2.92 2.92 0 0 1 5.84 0v1.75M7.58 9.33a.58.58 0 1 1-1.16 0 .58.58 0 0 1 1.16 0ZM2.92 5.83h8.16c.65 0 1.17.53 1.17 1.17v4.67c0 .64-.52 1.16-1.17 1.16H2.92c-.65 0-1.17-.52-1.17-1.16V7c0-.64.52-1.17 1.17-1.17Z" />,
);
/** Close. */
export const CloseIcon = /* @__PURE__ */ createIcon(
  'CloseIcon',
  '0 0 20 20',
  <path d="m5 5 10 10M15 5 5 15" />,
);
/** External link (opens the publisher's article in a new tab). */
export const ExternalIcon = /* @__PURE__ */ createIcon(
  'ExternalIcon',
  '0 0 16 16',
  <path d="M9 2.5h4.5V7M13.5 2.5 7 9M11.5 9.5v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3" />,
  { directional: true },
);
/** Google's "G" in its brand colour (sign-in button). */
export const GoogleIcon = /* @__PURE__ */ createIcon(
  'GoogleIcon',
  '0 0 18 18',
  <path
    className="fill-brand-google"
    stroke="none"
    d="M8.56 3.16c1.86 0 3.11.77 3.83 1.42l1.69-1.57A7.63 7.63 0 0 0 8.56 1a7.46 7.46 0 0 0-6.91 4.12l1.99 1.46c.54-1.46 2.58-3.42 4.92-3.42ZM1.65 5.12A6.4 6.4 0 0 0 1 7.94c0 1.01.23 1.96.65 2.83l1.99-1.46a3.5 3.5 0 0 1 0-2.73L1.65 5.12Zm6.91 9.72c-2.34 0-4.38-1.96-4.92-3.42l-1.99 1.46A7.46 7.46 0 0 0 8.56 17c2.17 0 4-.68 5.36-1.88l-1.9-1.41c-.76.51-1.94 1.13-3.46 1.13ZM17 8.13c0-.6-.07-1.06-.07-1.06H8.56v2.02h4.78c-.22 1.1-1.32 2.51-1.32 2.51v2.11l1.9 1.41C15.56 13.68 17 11.25 17 8.13Z"
  />,
  { fill: true },
);
/** Apple's logo (sign-in button). */
export const AppleIcon = /* @__PURE__ */ createIcon(
  'AppleIcon',
  '0 0 18 18',
  <path d="M14.37 10.5c-.04-2.67 1.93-3.95 2.04-4.01-1.16-1.38-2.96-1.58-3.6-1.6-1.5-.13-2.96.71-3.72.71-.77 0-1.95-.69-3.24-.66-1.65.01-3.18.77-4.02 1.97-1.75 2.45-.46 6.07 1.21 8.05.85.98 1.82 2.07 3.11 2.03 1.25-.04 1.75-.65 3.24-.65s1.95.65 3.25.6c1.34-.03 2.19-.99 3-1.97.95-1.11 1.34-2.2 1.36-2.24-.04-.02-2.59-.81-2.63-2.24ZM11.93 3.57c.68-.69 1.16-1.62 1.03-2.57-.99.03-2.23.56-2.93 1.23-.62.6-1.21 1.57-1.06 2.47 1.12.08 2.26-.45 2.96-1.13Z" />,
  { fill: true },
);
/** Filters (topic cards, filter sheets). */
export const SlidersIcon = /* @__PURE__ */ createIcon(
  'SlidersIcon',
  '0 0 20 20',
  <path d="M3.33 5.83h7.5M14.17 5.83h2.5M3.33 14.17h2.5M9.17 14.17h7.5M12.5 4.17v3.33M7.5 12.5v3.33" />,
);
/** Calendar (event dates). */
export const CalendarIcon = /* @__PURE__ */ createIcon(
  'CalendarIcon',
  '0 0 20 20',
  <path d="M6.67 1.67V5M13.33 1.67V5M2.5 8.33h15M4.17 3.33h11.66c.92 0 1.67.75 1.67 1.67v11.67c0 .92-.75 1.66-1.67 1.66H4.17c-.92 0-1.67-.74-1.67-1.66V5c0-.92.75-1.67 1.67-1.67Z" />,
);
/** Map pin (venues and locations). */
export const MapPinIcon = /* @__PURE__ */ createIcon(
  'MapPinIcon',
  '0 0 20 20',
  <path d="M16.67 8.33c0 4.17-6.67 10-6.67 10s-6.67-5.83-6.67-10a6.67 6.67 0 0 1 13.34 0ZM12.5 8.33a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />,
);
/** Organiser (people). */
export const UsersIcon = /* @__PURE__ */ createIcon(
  'UsersIcon',
  '0 0 20 20',
  <path d="M13.33 17.5v-1.67a3.33 3.33 0 0 0-3.33-3.33H5a3.33 3.33 0 0 0-3.33 3.33v1.67M18.33 17.5v-1.67a3.33 3.33 0 0 0-2.5-3.22M13.33 2.61a3.33 3.33 0 0 1 0 6.45M10.83 5.83a3.33 3.33 0 1 1-6.66 0 3.33 3.33 0 0 1 6.66 0Z" />,
);
/** Play (podcasts and videos). */
export const PlayIcon = /* @__PURE__ */ createIcon(
  'PlayIcon',
  '0 0 20 20',
  <path d="M5.83 3.33 15.83 10l-10 6.67V3.33Z" />,
  { fill: true, directional: true },
);
/** Clock (durations and quiet hours). */
export const ClockIcon = /* @__PURE__ */ createIcon(
  'ClockIcon',
  '0 0 20 20',
  <path d="M10 5v5l3.33 1.67M18.33 10a8.33 8.33 0 1 1-16.66 0 8.33 8.33 0 0 1 16.66 0Z" />,
);
/** Document (research reports). */
export const DocumentIcon = /* @__PURE__ */ createIcon(
  'DocumentIcon',
  '0 0 20 20',
  <path d="M11.67 1.67H5a1.67 1.67 0 0 0-1.67 1.66v13.34A1.67 1.67 0 0 0 5 18.33h10a1.67 1.67 0 0 0 1.67-1.66V6.67l-5-5ZM11.67 1.67v5h5M13.33 10.83H6.67M13.33 14.17H6.67" />,
);
/** Settings (notification preferences). */
export const SettingsIcon = /* @__PURE__ */ createIcon(
  'SettingsIcon',
  '0 0 20 20',
  <path d="M8.06 3.44a1.94 1.94 0 0 1 3.88 0 1.94 1.94 0 0 0 2.9 1.68 1.94 1.94 0 0 1 1.94 3.36 1.94 1.94 0 0 0 0 3.04 1.94 1.94 0 0 1-1.94 3.36 1.94 1.94 0 0 0-2.9 1.68 1.94 1.94 0 0 1-3.88 0 1.94 1.94 0 0 0-2.9-1.68 1.94 1.94 0 0 1-1.94-3.36 1.94 1.94 0 0 0 0-3.04 1.94 1.94 0 0 1 1.94-3.36 1.94 1.94 0 0 0 2.9-1.68ZM12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />,
);
/** Menu (three lines). */
export const MenuIcon = /* @__PURE__ */ createIcon(
  'MenuIcon',
  '0 0 20 20',
  <path d="M3.33 5h13.34M3.33 10h13.34M3.33 15h13.34" />,
);
/** Delete. */
export const TrashIcon = /* @__PURE__ */ createIcon(
  'TrashIcon',
  '0 0 20 20',
  <path d="M2.5 5h15M15.83 5v11.67c0 .83-.83 1.66-1.66 1.66H5.83c-.83 0-1.66-.83-1.66-1.66V5M6.67 5V3.33c0-.83.83-1.66 1.66-1.66h3.34c.83 0 1.66.83 1.66 1.66V5M8.33 9.17v5M11.67 9.17v5" />,
);
/** Edit (pencil). */
export const EditIcon = /* @__PURE__ */ createIcon(
  'EditIcon',
  '0 0 20 20',
  <path d="M14.17 2.5a2.36 2.36 0 0 1 3.33 3.33L6.25 17.08l-4.58 1.25 1.25-4.58L14.17 2.5Z" />,
);
/** Language (globe). */
export const GlobeIcon = /* @__PURE__ */ createIcon(
  'GlobeIcon',
  '0 0 20 20',
  <path d="M18.33 10a8.33 8.33 0 1 1-16.66 0 8.33 8.33 0 0 1 16.66 0ZM1.67 10h16.66M10 1.67a12.75 12.75 0 0 1 3.33 8.33A12.75 12.75 0 0 1 10 18.33 12.75 12.75 0 0 1 6.67 10 12.75 12.75 0 0 1 10 1.67Z" />,
);
/** Check (selected option, copied link). */
export const CheckIcon = /* @__PURE__ */ createIcon(
  'CheckIcon',
  '0 0 20 20',
  <path d="m4.17 10.83 3.33 3.34 8.33-8.34" />,
);
/** Link (copy link). */
export const LinkIcon = /* @__PURE__ */ createIcon(
  'LinkIcon',
  '0 0 20 20',
  <path d="M8.33 10.83a4.17 4.17 0 0 0 6.29.45l2.5-2.5a4.17 4.17 0 0 0-5.89-5.9l-1.43 1.43M11.67 9.17a4.17 4.17 0 0 0-6.29-.45l-2.5 2.5a4.17 4.17 0 0 0 5.89 5.9l1.42-1.43" />,
);
/** Sign out. */
export const LogOutIcon = /* @__PURE__ */ createIcon(
  'LogOutIcon',
  '0 0 20 20',
  <path d="M7.5 17.5H4.17A1.67 1.67 0 0 1 2.5 15.83V4.17A1.67 1.67 0 0 1 4.17 2.5H7.5M13.33 14.17 17.5 10l-4.17-4.17M17.5 10h-10" />,
  { directional: true },
);
/** Podcast (microphone). */
export const MicIcon = /* @__PURE__ */ createIcon(
  'MicIcon',
  '0 0 20 20',
  <path d="M10 1.67a2.5 2.5 0 0 0-2.5 2.5V10a2.5 2.5 0 0 0 5 0V4.17A2.5 2.5 0 0 0 10 1.67ZM15.83 8.33V10a5.83 5.83 0 0 1-11.66 0V8.33M10 15.83v2.5" />,
);
/** Privacy (shield). */
export const ShieldIcon = /* @__PURE__ */ createIcon(
  'ShieldIcon',
  '0 0 20 20',
  <path d="M16.67 10.83c0 4.17-2.92 6.25-6.39 7.46a.83.83 0 0 1-.56 0c-3.47-1.2-6.39-3.29-6.39-7.46V5a.83.83 0 0 1 .84-.83c1.66 0 3.75-1 5.2-2.27a.97.97 0 0 1 1.26 0c1.46 1.28 3.54 2.27 5.2 2.27a.83.83 0 0 1 .84.83v5.83Z" />,
);
/** Visibility (eye). */
export const EyeIcon = /* @__PURE__ */ createIcon(
  'EyeIcon',
  '0 0 20 20',
  <path d="M1.72 10.29a.83.83 0 0 1 0-.58 8.96 8.96 0 0 1 16.56 0 .83.83 0 0 1 0 .58 8.96 8.96 0 0 1-16.56 0ZM12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />,
);

// Arcel Konnect (009 revision 11): the frames' Iconly and Huge-icon glyphs, redrawn in the same 20 px stroke set.
/** Comments (speech bubble). */
export const CommentIcon = /* @__PURE__ */ createIcon(
  'CommentIcon',
  '0 0 20 20',
  <path d="M10 17.5a7.5 7.5 0 1 0-6.67-4.06L2.5 17.5l4.06-.83A7.46 7.46 0 0 0 10 17.5Z" />,
);
/** Send and share (paper plane). */
export const SendIcon = /* @__PURE__ */ createIcon(
  'SendIcon',
  '0 0 20 20',
  <path d="M17.5 2.5 9.17 10.83M17.5 2.5l-5.42 15-3.07-6.67L2.5 7.92l15-5.42Z" />,
  { directional: true },
);
/** Discover (compass). */
export const CompassIcon = /* @__PURE__ */ createIcon(
  'CompassIcon',
  '0 0 20 20',
  <path d="M10 18.33a8.33 8.33 0 1 0 0-16.66 8.33 8.33 0 0 0 0 16.66ZM13.53 6.47l-1.77 5.3-5.3 1.76 1.77-5.3 5.3-1.76Z" />,
);
/** Collections (folder). */
export const FolderIcon = /* @__PURE__ */ createIcon(
  'FolderIcon',
  '0 0 20 20',
  <path d="M2.5 5.83A1.67 1.67 0 0 1 4.17 4.17h3.33l1.67 1.66h6.66a1.67 1.67 0 0 1 1.67 1.67v6.67a1.67 1.67 0 0 1-1.67 1.66H4.17a1.67 1.67 0 0 1-1.67-1.66V5.83Z" />,
);
/** Trending (flame). */
export const FlameIcon = /* @__PURE__ */ createIcon(
  'FlameIcon',
  '0 0 20 20',
  <path d="M10 18.33c3.22 0 5.83-2.42 5.83-5.83 0-4.17-3.33-5.83-3.33-9.17-2.5 1.67-3.33 4.17-3.33 5.84-1.25-.84-1.67-2.5-1.67-2.5C5.83 8.33 4.17 10 4.17 12.5c0 3.4 2.61 5.83 5.83 5.83Z" />,
  { fill: true },
);
/** Help and support (headphones). */
export const HeadphonesIcon = /* @__PURE__ */ createIcon(
  'HeadphonesIcon',
  '0 0 20 20',
  <path d="M2.5 13.33V10a7.5 7.5 0 0 1 15 0v3.33M17.5 14.17a1.67 1.67 0 0 1-1.67 1.66H15a1.67 1.67 0 0 1-1.67-1.66v-2.5A1.67 1.67 0 0 1 15 10h2.5v4.17ZM2.5 14.17a1.67 1.67 0 0 0 1.67 1.66H5a1.67 1.67 0 0 0 1.67-1.66v-2.5A1.67 1.67 0 0 0 5 10H2.5v4.17Z" />,
);
/** Theme (half-filled circle). */
export const ContrastIcon = /* @__PURE__ */ createIcon(
  'ContrastIcon',
  '0 0 20 20',
  <>
    <circle cx="10" cy="10" r="7.5" />
    <path d="M10 2.5v15a7.5 7.5 0 0 0 0-15Z" fill="currentColor" />
  </>,
);
/** More actions (three dots). */
export const MoreIcon = /* @__PURE__ */ createIcon(
  'MoreIcon',
  '0 0 20 20',
  <>
    <circle cx="4.17" cy="10" r="1.67" />
    <circle cx="10" cy="10" r="1.67" />
    <circle cx="15.83" cy="10" r="1.67" />
  </>,
  { fill: true },
);
/** Report (flag). */
export const FlagIcon = /* @__PURE__ */ createIcon(
  'FlagIcon',
  '0 0 20 20',
  <path d="M3.33 18.33V3.33m0 0h10l-1.66 3.34 1.66 3.33h-10" />,
);
/** Light mode (sun). */
export const SunIcon = /* @__PURE__ */ createIcon(
  'SunIcon',
  '0 0 20 20',
  <path d="M10 13.33a3.33 3.33 0 1 0 0-6.66 3.33 3.33 0 0 0 0 6.66ZM10 1.67v1.66M10 16.67v1.66M4.11 4.11l1.18 1.18M14.71 14.71l1.18 1.18M1.67 10h1.66M16.67 10h1.66M4.11 15.89l1.18-1.18M14.71 5.29l1.18-1.18" />,
);
/** Dark mode (moon). */
export const MoonIcon = /* @__PURE__ */ createIcon(
  'MoonIcon',
  '0 0 20 20',
  <path d="M17.5 10.66A7.5 7.5 0 1 1 9.34 2.5a5.83 5.83 0 0 0 8.16 8.16Z" />,
);
/** A quotation (closing marks). */
export const QuoteIcon = /* @__PURE__ */ createIcon(
  'QuoteIcon',
  '0 0 20 20',
  <path d="M3.33 4.17h5v5c0 3.33-1.66 5.83-5 6.66v-2.5c1.67-.83 2.5-2.08 2.5-4.16h-2.5v-5Zm8.34 0h5v5c0 3.33-1.67 5.83-5 6.66v-2.5c1.66-.83 2.5-2.08 2.5-4.16h-2.5v-5Z" />,
  { fill: true },
);
/** A ticked circle (selected). */
export const CheckCircleIcon = /* @__PURE__ */ createIcon(
  'CheckCircleIcon',
  '0 0 20 20',
  <path d="M10 18.33a8.33 8.33 0 1 0 0-16.66 8.33 8.33 0 0 0 0 16.66Zm-3.33-8.33 2.5 2.5 4.16-5" />,
);
/** Send a comment (arrow up). */
export const ArrowUpIcon = /* @__PURE__ */ createIcon(
  'ArrowUpIcon',
  '0 0 20 20',
  <path d="M10 15.83V4.17M4.17 10 10 4.17 15.83 10" />,
);
/** A wallet (009 revision 16, K68: My subscriptions). */
export const WalletIcon = /* @__PURE__ */ createIcon(
  'WalletIcon',
  '0 0 24 24',
  <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />,
);
/** A receipt (009 revision 16, K68: Billing history). */
export const ReceiptIcon = /* @__PURE__ */ createIcon(
  'ReceiptIcon',
  '0 0 24 24',
  <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1ZM16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 17.5v-11" />,
);
/** Translate (009 revision 16: a story in the reader's language). */
export const TranslateIcon = /* @__PURE__ */ createIcon(
  'TranslateIcon',
  '0 0 24 24',
  <path d="m5 8 6 6M4 14l6-6 2-3M2 5h12M7 2h1M22 22l-5-10-5 10M14 18h6" />,
);
/** Chat (009 revision 21: the messages in the reader header). */
export const ChatIcon = /* @__PURE__ */ createIcon(
  'ChatIcon',
  '0 0 24 24',
  <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22ZM8 10h8M8 14h5" />,
);
/** Block (009 revision 21: block a reader). */
export const BlockIcon = /* @__PURE__ */ createIcon(
  'BlockIcon',
  '0 0 24 24',
  <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM4.93 4.93l14.14 14.14" />,
);

// 009 revision 23 (the feedback sheet and Download your data, from the attachments of 2026-10-06): the same stroke set.
/** A problem (bug). */
export const BugIcon = /* @__PURE__ */ createIcon(
  'BugIcon',
  '0 0 24 24',
  <path d="M8 6.5 6.5 5M16 6.5 17.5 5M9 6.13V5a3 3 0 0 1 6 0v1.13M12 20v-8M5 13H3M21 13h-2M5.5 9.5 3.5 8M18.5 9.5l2-1.5M5.5 17l-2 1.5M18.5 17l2 1.5M12 20a6 6 0 0 0 6-6v-3a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6 6 0 0 0 6 6Z" />,
);
/** A suggestion (light bulb). */
export const LightbulbIcon = /* @__PURE__ */ createIcon(
  'LightbulbIcon',
  '0 0 24 24',
  <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.6.45 1.1 1.2 1.1 2V16h5v-.2c0-.8.5-1.55 1.1-2A6 6 0 0 0 12 3Z" />,
);
/** Add an image. */
export const ImageIcon = /* @__PURE__ */ createIcon(
  'ImageIcon',
  '0 0 24 24',
  <path d="M21 12v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6M3 16l4.3-4.3a2 2 0 0 1 2.8 0L15 16.6M13.5 15l1.3-1.3a2 2 0 0 1 2.8 0L21 17M9 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM18 2v6M15 5h6" />,
);
/** Download. */
export const DownloadIcon = /* @__PURE__ */ createIcon(
  'DownloadIcon',
  '0 0 24 24',
  <path d="M12 3v12M7 10l5 5 5-5M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />,
);
